var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-2"},[_vm._v(" Manage Academies ")])
}
var staticRenderFns = []

export { render, staticRenderFns }